import {CreatorSearchResult} from '@/types/models/creator-crm/creatorCrm';

function mapCreatorsForAnalytics(creators: CreatorSearchResult[]) {
  return creators.map((creator) => ({
    name: creator.fullName,
    username: creator.username,
    is_onboarded: creator.isOnboarded,
  }));
}

export default mapCreatorsForAnalytics;
